
import React from 'react';

import CrmTest from './components/CrmTest';
import CrmReport from './components/CrmReport';
import CrmNewsletter from './components/CrmNewsletter';
import ToolTabs from './components/ToolTabs';
import ScheduledNewsletters from './components/CrmScheduled';

export default class CrmTool extends React.Component {
    render() {
        const props = this.props;
        
        var activeClients = props.clients.filter( client => { return client.status === "active"; }).reverse();
        var clientArr = [];
        for (var i = activeClients.length - 1; i >= 0; i--) {
            clientArr.push(
                {
                    "name" : activeClients[i].name,
                    "value" : activeClients[i].clientCode,
                },
            );
        }

        return (
            <div id="crmtest" className="col crmtest">
                <section>
                    <ToolTabs />
                    <div id="crmtest-inputs" className="inputs">
                        <div id="crmtest-1" className="tab crmtest-1 active">
                            <CrmTest
                                clients={clientArr}
                            />
                        </div>
                        <div id="crmtest-2" className="tab crmtest-2">
                            <CrmNewsletter
                                clients={clientArr}
                                sgTemplates={props.sgTemplates}
                            />
                        </div>
                        <div id="crmtest-3" className="tab crmtest-3">
                            <ScheduledNewsletters />
                        </div>
                        <div id="crmtest-4" className="tab crmtest-4">
                            <CrmReport
                                sgTemplates={props.sgTemplates}
                            />
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component_crmTest/CrmTool.js